import { ref } from 'vue'
import { divIcon } from 'leaflet'
import Vue from 'vue'
import AntennaIcon from '@/Icons/AntennaIcon.vue'
import SatelliteWaveIcon from '@/Icons/SatelliteWaveIcon.vue'

export function useMapIcons() {
  const satelliteIcon = ref(null)
  const stationActiveIcon = ref(null)
  const stationInactiveIcon = ref(null)
  const stationReceivingIcon = ref(null)

  function createStationIcon(color, size) {
    const Constructor = Vue.extend(AntennaIcon)
    const instance = new Constructor({
      propsData: { 
        color,
        size 
      }
    })
    instance.$mount()
    
    return divIcon({
      html: instance.$el.outerHTML,
      className: '',
      iconSize: [size, size],
      iconAnchor: [size / 2, size / 2]
    })
  }

  function createSatelliteIcon(colour, size, waves = false) {
    const Constructor = Vue.extend(SatelliteWaveIcon)
    const instance = new Constructor({
      propsData: {
        colour,
        size,
        waves
      }
    })
    instance.$mount()
    
    return divIcon({
      html: instance.$el.outerHTML,
      className: 'satellite-icon',
      iconSize: [size, size],
      iconAnchor: [size / 2, size / 2]
    })
  }

  function updateIconSizes(zoomLevel) {
    const baseSize = 4
    const scaleFactor = 0.95
    const newSize = baseSize * Math.pow(scaleFactor, 3 - zoomLevel)
    
    // Create satellite icon with the new component
    satelliteIcon.value = createSatelliteIcon('#00008B', 20, false) // Dark blue, fixed size of 12
    // ff3b30 lo mismo este queda bien, es el mismo que el del circulo del ping
    //satelliteIcon.value = createSatelliteIcon('#FFFFFF', 20, false)
    
    // Use AntennaIcon component for stations with different colors
    // stationActiveIcon.value = createStationIcon('#4CAF50', 6 + newSize) // Green
    stationActiveIcon.value = createStationIcon('#39FF14', 7 + newSize) // Neon green
    stationInactiveIcon.value = createStationIcon('#ff3333', 4 + newSize) // Red
  
  // Use AntennaIcon component for stations with different colors
  // Suggestion: Vibrant orange for the "receiving" state to draw attention
    //stationReceivingIcon.value = createStationIcon('#FFC107', 12 + newSize) // Yellow/Amber
    stationReceivingIcon.value = createStationIcon('#FFA500', 12 + newSize)

  }

  function getStationIcon(status, isReceiving = false) {
    if (isReceiving) return stationReceivingIcon.value
    return status === 0 ? stationInactiveIcon.value : stationActiveIcon.value
  }

  return {
    satelliteIcon,
    stationActiveIcon,
    stationInactiveIcon,
    stationReceivingIcon,
    updateIconSizes,
    getStationIcon,
    createSatelliteIcon // Export for per-satellite icon creation
  }
}